(function(){
	angular.module('app.privacyPolicy')
		.controller('privacyPolicyCtrl',['$scope',
			function($scope){

	}]);
}());
